import React from 'react';

const TabsPanel = ({ tabs, activeTab }) => {
  return (
    <div>
      {tabs.map((tab, index) => {
        if (activeTab === index)
          return (
            <div key={index} hidden={activeTab !== index}>
              {tab.component}
            </div>
          );
      })}
    </div>
  );
};

export default TabsPanel;
